import React, { useEffect } from "react";

export default function LetsDiscuss() {
  useEffect(() => {
    // Ensure Calendly script is loaded
    if (
      !document.querySelector(
        'script[src="https://assets.calendly.com/assets/external/widget.js"]'
      )
    ) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  return (
    <>
      <section
        className="lets-discuss-section active"
        id="lets-discuss-section"
      >
        <div className="row ">
          <div className="container">
            <div className="lets-discuss-wrap">
              <div className="title wow zoomIn">
                <h2>
                  Let’s discuss your{" "}
                  <span className="red">Snapshot Videos</span>{" "}
                </h2>
              </div>
              <p className="wow fadeInLeft">
                Call now (800) 820-6020 or schedule the time best for you.
              </p>
              <div className="lets-discuss-calander wow fadeInRight">
                <div className="lets-discuss-calander-box">
                  <div
                    className="calendly-inline-widget wow fadeInRight"
                    data-url="https://calendly.com/jimwacksman/snapshot-videos-discussion?hide_gdpr_banner=1"
                    style={{ minWidth: "320px", height: "700px" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
